var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"clearable":_vm.clearable},on:{"change":_vm.onChange}},_vm._l((_vm.items),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.year,"value":item.year}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }